import { Box, Card, CardContent, Typography } from '@mui/material';

import StlSwitch from 'features/common/StlSwitch/StlSwitch';
import { light_gray_text } from 'theme/cemTheme';

import alertStyles from './AlertCard.module.css';

interface AlertCardProps {
  title: string;
  description: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function AlertCard({
  title,
  description,
  checked,
  onChange,
  disabled = false,
}: AlertCardProps) {
  return (
    <Card variant="outlined" className={alertStyles.alertCard}>
      <CardContent className={alertStyles.alertCardContent}>
        <Box>
          <Typography variant="h4">{title}</Typography>
          <Typography variant="caption" color={light_gray_text}>
            {description}
          </Typography>
        </Box>
        <StlSwitch
          sx={{ padding: '0.25rem' }}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
      </CardContent>
    </Card>
  );
}
